export default __webpack_public_path__ + "static/media/mike.1da0d4fd.png";